// Sound.
//
// `ui/sfx.ts` is a tiny WebAudio synth that takes an `enabled` flag, because the
// old build passed `state.settings.soundEnabled` at every call site. Three
// screens means three chances to forget, and a mute toggle that still makes a
// noise is worse than no toggle — so the gate lives here once.
//
// The old build's only calls were in the Flock/Inspector panel, which U7 deleted:
// a peep on handling a bird, a cluck on saving her name and on equipping a
// cosmetic. Name and cosmetics have no v1 screen, so those two are simply gone.
// What is left is the three moments an existing sfx was written for — the peep
// on handling, the cluck on feeding a flock, and the pop on a chore done.

import type { GameStateStore } from '../core/store';
import { cluck, peep, pop } from '../ui/sfx';

/** Handling a bird calms her, and she says so. */
export function playHandled(store: GameStateStore): void {
  peep(store.getState().settings.soundEnabled);
}

/** The flock got fed. */
export function playFed(store: GameStateStore): void {
  cluck(store.getState().settings.soundEnabled);
}

/** A chore is done — the tick that makes a tap feel like it landed. */
export function playChoreDone(store: GameStateStore): void {
  pop(store.getState().settings.soundEnabled);
}
